import { Box, Link, Typography } from '@mui/material';
import React from 'react';
import { useHref, useNavigate } from 'react-router-dom';
import errorImageMedium from '../assets/errorImageMedium.svg';
import { useCommonWebTranslation } from '../hooks';
import { getErrorMessage } from '../utils';
import { getDefaultErrorMessage } from '../utils/getDefaultErrorMessage';
import { getDefaultErrorTitle } from '../utils/getDefaultErrorTitle';
export const PageError = (props) => {
    const { t } = useCommonWebTranslation();
    const defaultTitle = getDefaultErrorTitle(props.type, t);
    let defaultMessage = getDefaultErrorMessage(props.type, t);
    if (props.error) {
        defaultMessage = getErrorMessage(props.error);
        if (!defaultMessage.endsWith('.') && !defaultMessage.endsWith('?') && !defaultMessage.endsWith('!')) {
            defaultMessage += '.';
        }
    }
    return (React.createElement(Box, { sx: {
            boxSizing: 'border-box',
            width: '100%',
            height: '100%',
            py: 4,
            overflowX: 'hidden',
            overflowY: 'auto',
            display: 'flex',
        }, "data-test": 'page-error' },
        React.createElement(Box, { sx: { margin: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' } },
            React.createElement("img", { src: errorImageMedium, alt: '', style: { display: 'block', width: 'calc(min(560px, 100%)' } }),
            React.createElement(Typography, { variant: 'h1', sx: { mt: 4, textAlign: 'center', scale: { xs: '80%', sm: '100%' } }, "data-test": 'error-title' }, props.title ? props.title : defaultTitle),
            React.createElement(Box, { sx: { mt: 2, px: 4, textAlign: 'center' } },
                (props.message || defaultMessage) && (React.createElement(Typography, { variant: 'body1', sx: { px: 0.5, display: 'inline-block' }, "data-test": 'error-message' }, props.message ? props.message : defaultMessage)),
                props.type !== 'access-issue' && (React.createElement(Typography, { variant: 'body1', sx: { px: 0.5, display: 'inline-block' } }, props.description ? props.description : React.createElement(DefaultDescription, null)))))));
};
const DefaultDescription = ({ homepageHref, onPreviousPageClick, onHomepageClick }) => {
    const { t } = useCommonWebTranslation();
    const navigate = useNavigate();
    const defaultHref = useHref('/');
    const description = t('pageError.description');
    const parts = description.split(/({{\w+}})/).map((part) => {
        switch (part) {
            case '{{previousPage}}':
                return (React.createElement(Link, { key: part, onClick: onPreviousPageClick ? () => onPreviousPageClick(navigate) : () => navigate(-1), sx: { cursor: 'pointer' } }, t('pageError.previousPage')));
            case '{{homepage}}':
                return (React.createElement(Link, { key: part, href: homepageHref !== null && homepageHref !== void 0 ? homepageHref : defaultHref, onClick: onHomepageClick ? () => onHomepageClick(navigate) : () => navigate('/') }, t('pageError.homepage')));
            default:
                return React.createElement("span", { key: part }, part);
        }
    });
    return React.createElement(React.Fragment, null, parts);
};
